import * as React from 'react'
import { MessageProps } from './types'
import classNames from 'classnames'

const Message = ({ color, children }: MessageProps) => {
    return (
        <div
            className={classNames(
                `border-t-2 p-4`,
                { 'border-brand-red bg-brand-grey100': color === 'red' },
                { 'border-brand-green bg-brand-grey050': color === 'green' }
            )}
        >
            {children}
        </div>
    )
}

export default Message
